import SideNavigation from '@/components/Common/SideNavigation/SideNavigation';
import TopNav from '@/components/Common/TopNav/TopNav';
import styles from '@/layouts/MainLayout/MainLayout.styles';
import { MainLayoutProps } from '@/layouts/MainLayout/MainLayout.utils';
import { Box, Stack } from '@mui/material';

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <Stack sx={styles.wrapper} direction="row">
      <SideNavigation />
      <Stack sx={styles.containerRight}>
        <TopNav />
        <Box sx={styles.body}>{children}</Box>
      </Stack>
    </Stack>
  );
};
